import React from 'react';
import PlayerCount from './PlayerCount';
import IPButton from './IPButton';

const TopHeader = () => (
  <div className="header-top" style={{ display: 'block', backgroundColor: 'rgb(30, 35, 35)' }}>
    <div className="container">
      <div className="item ip">
        <IPButton />
      </div>
      <div className="item players">
        <PlayerCount />
      </div>
      <div className="item account">
        Mon compte
      </div>
    </div>
  </div>
);

export default TopHeader;



// WEBPACK FOOTER //
// ./src/layout/TopHeader.js